"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const react_facebook_login_1 = __importDefault(require("react-facebook-login"));
const react_google_login_1 = require("react-google-login");
require("./Login.scss");
const response_codes_1 = require("../../../assets/constants/response_codes");
const constants_1 = require("../../../assets/constants/constants");
const strings_1 = require("../../../assets/strings/strings");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const users_1 = require("../../../utils/users");
const auth_requests_1 = require("../../../dataSource/auth_requests");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const validations_1 = require("../../../utils/validations");
const google_icon_svg_1 = __importDefault(require("../../../assets/images/google-icon.svg"));
const AccessWrapper_1 = __importDefault(require("../accessWrapper/AccessWrapper"));
const useHubspot_1 = __importDefault(require("../../../utils/useHubspot"));
const helpers_1 = require("../../../utils/helpers");
// TODO: [XP360-888] Refatorar login de redes sociais e transformar em um componente
const Login = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [formLogin] = antd_1.Form.useForm();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [disabledGoogle, setDisabledGoogle] = (0, react_1.useState)(false);
    const { dispatch } = (0, useHubspot_1.default)();
    (0, react_1.useEffect)(() => {
        if ((0, users_1.checkUserIsAuth)()) {
            history.push(RoutesPaths_1.routesPaths.root);
        }
    }, [history]);
    const hubspotHandleLogin = (email, pageName) => {
        dispatch({
            fields: [{ name: 'email', value: email }],
            context: {
                pageName: pageName || 'Login',
                pageUri: RoutesPaths_1.routesPaths.login,
                hutk: '',
            },
        });
    };
    const handleLoginResponse = (0, react_1.useCallback)((response, pageName) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(false);
        if (!response.isError) {
            // Encrypty and save in local storage
            (0, users_1.saveLoginUserData)(response.token, response.permissions, response.currentUser);
            hubspotHandleLogin(response.currentUser.email, pageName);
            // retorna para a última página caso exista no storage
            const lastPage = (0, users_1.getLastPageBeforeLogin)();
            if (lastPage) {
                history.push(lastPage);
            }
            else {
                history.push(RoutesPaths_1.routesPaths.root);
            }
        }
        else {
            switch (response.code) {
                case response_codes_1.LoginCodes.error.INVALID_CREDENTIALS:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.emailOrPasswordInvalid,
                        description: strings_1.LoginPageMessages.login.verifyAndTryAgain,
                    });
                    break;
                case response_codes_1.LoginCodes.error.FACEBOOK_ACCOUNT_NOT_FOUND:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.facebookAccountNotFound,
                        description: strings_1.LoginPageMessages.login.createAccount,
                    });
                    break;
                case response_codes_1.LoginCodes.error.FACEBOOK_COMMUNICATION:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.facebookCommunicationError,
                    });
                    break;
                case response_codes_1.LoginCodes.error.GOOGLE_ACCOUNT_NOT_FOUND:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.googleAccountNotFound,
                        description: strings_1.LoginPageMessages.login.createAccount,
                    });
                    break;
                case response_codes_1.LoginCodes.error.GOOGLE_COMMUNICATION:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.googleCommunicationError,
                    });
                    break;
                case response_codes_1.LoginCodes.error.USER_NOT_ACTIVATED:
                    message_utils_1.default.error({
                        message: strings_1.LoginPageMessages.login.inactiveUser,
                        description: strings_1.LoginPageMessages.login.contactYourBranch,
                    });
                    break;
                default:
                    message_utils_1.default.error();
                    break;
            }
            (0, users_1.removeUserFromStorage)();
        }
    }), [history]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const email = formLogin.getFieldValue('email');
        const password = formLogin.getFieldValue('password');
        const bookingId = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
        const response = yield (0, auth_requests_1.userAuthenticate)({
            email,
            password,
            bookingId,
        });
        handleLoginResponse(response, 'Login');
    }), [formLogin, handleLoginResponse]);
    const responseFacebook = (0, react_1.useCallback)((facebookResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if (facebookResponse.accessToken) {
            const bookingId = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
            const response = yield (0, auth_requests_1.userAuthenticateWithFacebook)({
                accessToken: facebookResponse.accessToken,
                bookingId,
            });
            if (response.code === 2002) {
                const { email } = response.currentUser;
                message_utils_1.default.success({
                    message: strings_1.RegisterMessages.successfulRegistration,
                    description: `${strings_1.RegisterMessages.emailSentTo1of2} ${email} ${strings_1.RegisterMessages.emailSentTo2of2} `,
                });
            }
            handleLoginResponse(response, 'loginFb');
        }
        else {
            message_utils_1.default.error({
                message: strings_1.LoginPageMessages.login.facebookAuthenticationError,
            });
        }
    }), [handleLoginResponse]);
    const responseGoogle = (0, react_1.useCallback)((googleResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if (googleResponse.accessToken) {
            const bookingId = (0, helpers_1.decrypty)(localStorage.getItem(constants_1.LOCAL_STORAGE.bookingId));
            const response = yield (0, auth_requests_1.userAuthenticateWithGoogle)({
                accessToken: googleResponse.tokenObj.id_token,
                bookingId,
            });
            if (response.code === 2002) {
                const { email } = response.currentUser;
                message_utils_1.default.success({
                    message: strings_1.RegisterMessages.successfulRegistration,
                    description: `${strings_1.RegisterMessages.emailSentTo1of2} ${email} ${strings_1.RegisterMessages.emailSentTo2of2} `,
                });
            }
            handleLoginResponse(response, 'loginGoogle');
        }
        else {
            message_utils_1.default.error({
                message: strings_1.LoginPageMessages.login.googleAuthenticationError,
            });
        }
    }), [handleLoginResponse]);
    const responseFailureGoogle = (0, react_1.useCallback)((googleResponse) => __awaiter(void 0, void 0, void 0, function* () {
        if (googleResponse.error == 'idpiframe_initialization_failed') {
            message_utils_1.default.error({
                message: 'Para entrar com o Google é necessário desbloquear cookies de terceiros nas configurações do navegador.',
            });
            setDisabledGoogle(true);
        }
        else {
            message_utils_1.default.error({
                message: strings_1.LoginPageMessages.login.googleAuthenticationError,
            });
        }
    }), [handleLoginResponse]);
    (0, react_1.useEffect)(() => {
        document.title = '360 Suítes - Login';
    }, []);
    return (react_1.default.createElement("div", { className: "Login" },
        react_1.default.createElement(AccessWrapper_1.default, null,
            react_1.default.createElement("div", { className: "form-container" },
                react_1.default.createElement("div", { className: "login-header" },
                    "Entrar na",
                    react_1.default.createElement("span", null, " \u00E1rea de h\u00F3spedes "),
                    "da 360 Su\u00EDtes"),
                react_1.default.createElement(react_facebook_login_1.default, { appId: constants_1.FACEBOOK_ID, autoLoad: false, fields: "name,email,picture", callback: responseFacebook, icon: "fa-facebook", textButton: "Entrar com Facebook", cssClass: "btn-social-login", isMobile: false }),
                react_1.default.createElement(react_google_login_1.GoogleLogin, { clientId: constants_1.GOOGLE_ID, buttonText: "Login", autoLoad: false, onSuccess: responseGoogle, onFailure: responseFailureGoogle, cookiePolicy: "single_host_origin", render: renderProps => (react_1.default.createElement(antd_1.Tooltip, { title: disabledGoogle ? 'Para entrar com o Google é necessário desbloquear cookies de terceiros nas configurações do navegador.' : '' },
                        react_1.default.createElement(antd_1.Button, { className: `btn-social-login ${!disabledGoogle ? 'btn-social-login-active' : 'btn-social-login-disabled'}`, disabled: disabledGoogle, onClick: renderProps.onClick },
                            react_1.default.createElement("img", { src: google_icon_svg_1.default, className: "social-icon", alt: "Google Icon" }),
                            "Entrar com",
                            react_1.default.createElement("span", { className: "media-name" }, "Google")))) }),
                react_1.default.createElement("div", { className: "or-sep" },
                    react_1.default.createElement("div", { className: "line-through" }),
                    react_1.default.createElement("div", { className: "or-text" }, "ou")),
                react_1.default.createElement(antd_1.Form, { form: formLogin, className: "login-form", onFinish: () => handleSubmit(), noValidate: true },
                    react_1.default.createElement(antd_1.Form.Item, { name: "email", rules: [
                            {
                                required: true,
                                message: strings_1.FieldsMessages.email.insertYourEmail,
                            },
                            {
                                type: 'email',
                                message: strings_1.FieldsMessages.email.invalidEmailFormat,
                            },
                            {
                                pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                                message: strings_1.FieldsMessages.email.dontUseSpecialCharacters,
                            },
                        ] },
                        react_1.default.createElement(antd_1.Input, { className: "input-field", type: "email", placeholder: "E-mail" })),
                    react_1.default.createElement(antd_1.Form.Item, { name: "password", rules: (0, validations_1.fieldPasswordRules)() },
                        react_1.default.createElement(antd_1.Input, { className: "input-field", type: "password", placeholder: "Senha" })),
                    react_1.default.createElement(antd_1.Form.Item, null,
                        react_1.default.createElement(antd_1.Button, { type: "primary", htmlType: "submit", className: "btn-login", loading: isLoading }, "Entrar"))),
                react_1.default.createElement("div", { className: "login-footer" },
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.forgotPassword }, "Esqueceu sua senha?")),
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("span", null,
                            "N\u00E3o possui conta? \u00A0",
                            react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.register }, "Criar uma conta")),
                        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.root }, "Voltar para o site 360 Su\u00EDtes")))))));
};
exports.default = Login;
